import { Model } from './Model';

export enum AuthType {
  token = 'token',
  apiKey = 'apiKey'
}

export interface Instance extends Model {
  name: string,
  description: string,
  apiKey: string,
  authType?: AuthType
}